import Crud from '../components/UserLogs/Crud.vue'


let routes = {
    path: '/userlogs',
    component: resolve => require(['../components/layout/AdminApp'], resolve),
    children: [
      {
        path: '/userlogs',
        name: 'Logs de Usuario',
        component: Crud
      },
  ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/userlogs.js